import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody, Table, Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Spinner } from "reactstrap";
import { get, post, post_new, del } from "../../helpers/api_helper"; // We use post for both create and update
import Breadcrumbs from "../../components/Common/Breadcrumb";

const Categories = () => {
  document.title = "Categorii | PagaSunt Admin";

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  
  // State for the text fields
  const [currentCategory, setCurrentCategory] = useState({ 
    id: null, 
    name: "", 
    parent_id: "", 
    slug: "", // Added this
    icon: "fa-tag", 
    color: "#5b73e8",
    image_url: null 
  });

  // State specifically for the file object
  const [selectedFile, setSelectedFile] = useState(null);


  const [categoriesTree, setCategoriesTree] = useState([]); // For the table
const [allCategoriesFlat, setAllCategoriesFlat] = useState([]); // For the dropdown



const RenderCategoryRows = ({ category, level = 0, handleEdit, handleDelete }) => {
  return (
    <React.Fragment>
      <tr>
        <td style={{ paddingLeft: `${level * 20 + 12}px` }}>
          {category.image_url ? (
            <img src={category.image_url} alt="icon" style={{ width: "25px", height: "25px", objectFit: "contain" }} />
          ) : (
            <i className={`fa ${category.icon}`} style={{ color: category.color }}></i>
          )}
        </td>
        <td style={{ paddingLeft: `${level * 20}px` }}>
           {level > 0 ? "— " : ""}<strong>{category.name}</strong>
        </td>
        <td>{category.children_recursive?.length || 0} sub-items</td>
        <td>{category.slug}</td>
        <td>
          <Button size="sm" color="link" onClick={() => handleEdit(category)}>Edit</Button>
          <Button size="sm" color="link" className="text-danger" onClick={() => handleDelete(category.id)}>Șterge</Button>
        </td>
      </tr>
      {/* Recursion starts here */}
      {category.children_recursive && category.children_recursive.map((child) => (
        <RenderCategoryRows 
          key={child.id} 
          category={child} 
          level={level + 1} 
          handleEdit={handleEdit} 
          handleDelete={handleDelete} 
        />
      ))}
    </React.Fragment>
  );
};


const buildTree = (flat) => {
  const map = new Map();
  const roots = [];

  flat.forEach(item => {
    map.set(item.id, { ...item, children_recursive: [] });
  });

  flat.forEach(item => {
    const node = map.get(item.id);
    if (item.parent_id === null) {
      roots.push(node);
    } else {
      const parent = map.get(item.parent_id);
      if (parent) {
        parent.children_recursive.push(node);
      }
    }
  });

  // Optional: sort children by name or id
  const sortChildren = (nodes) => {
    nodes.sort((a, b) => a.name.localeCompare(b.name));
    nodes.forEach(n => {
      if (n.children_recursive.length) sortChildren(n.children_recursive);
    });
  };
  sortChildren(roots);

  return roots;
};

const fetchCategories = async () => {
  setLoading(true);
  try {
    const response = await get("/admin/categories");
    if (response.status === "success") {
      const builtTree = buildTree(response.data.flat);   // ← use flat here
      setCategoriesTree(builtTree);
      setAllCategoriesFlat(response.data.flat);
    }
  } catch (error) {
    console.error("Error fetching categories", error);
  }
  setLoading(false);
};


  useEffect(() => { fetchCategories(); }, []);

  const toggleModal = () => {
    setModal(!modal);
    if (modal) {
      setIsEdit(false);
      setCurrentCategory({ id: null, name: "", parent_id: "", icon: "fa-tag", color: "#5b73e8", image_url: null });
      setSelectedFile(null);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
    }
  };


  const flattenTree = (items, depth = 0) => {
  let result = [];
  items.forEach((item) => {
    // Add the current item with its depth
    result.push({ ...item, depth });
    // If it has children, flatten them too and increase depth
    if (item.children_recursive && item.children_recursive.length > 0) {
      result = result.concat(flattenTree(item.children_recursive, depth + 1));
    }
  });
  return result;
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // We must use FormData for file uploads
    const formData = new FormData();
    formData.append("name", currentCategory.name);
    formData.append("parent_id", currentCategory.parent_id || "");
    formData.append("icon", currentCategory.icon || "fa-tag");
    formData.append("color", currentCategory.color || "#5b73e8");
    formData.append("slug", currentCategory.slug || "");

    if (selectedFile) {
      formData.append("image_icon", selectedFile);
    }

    try {
      if (isEdit) {
        // Laravel File Upload Trick: 
        // Use POST but tell Laravel it's a PUT request via _method
        formData.append("_method", "PUT");
        await post_new(`/admin/categories/${currentCategory.id}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } else {
        await post_new("/admin/categories", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }
      fetchCategories();
      toggleModal();
    } catch (error) {
      console.error("Error saving category", error);
      alert("A apărut o eroare la salvarea categoriei.");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Sigur vrei să ștergi această categorie?")) {
      await del(`/admin/categories/${id}`);
      fetchCategories();
    }
  };

  const handleEdit = (cat) => {
    setCurrentCategory({
      id: cat.id,
      name: cat.name,
      slug: cat.slug || "", // Added this
      parent_id: cat.parent_id || "",
      icon: cat.icon || "fa-tag",
      color: cat.color || "#5b73e8",
      image_url: cat.image_url // This comes from the Appends in Laravel Model
    });
    setIsEdit(true);
    setModal(true);
  };


  const dropdownOptions = flattenTree(categoriesTree);


  const slugify = (text) => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')     // Replace spaces with -
    .replace(/[^\w-]+/g, '')   // Remove all non-word chars
    .replace(/--+/g, '-');    // Replace multiple - with single -
};


const handleNameChange = (e) => {
  const newName = e.target.value;
  // If we are NOT in edit mode, or if the slug is currently empty/matching the old name
  // we can auto-update the slug
  if (!isEdit) {
     setCurrentCategory({
       ...currentCategory, 
       name: newName, 
       slug: slugify(newName) 
     });
  } else {
     setCurrentCategory({ ...currentCategory, name: newName });
  }
};


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="PagaSunt" breadcrumbItem="Categorii" />
          
          <Row className="mb-3">
            <Col>
              <Button color="primary" onClick={toggleModal}>
                <i className="mdi mdi-plus me-1"></i> Adaugă Categorie Nouă
              </Button>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {loading ? <div className="text-center"><Spinner /></div> : (
                    <Table responsive className="table-centered table-nowrap mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Icon / Imagine</th>
                          <th>Nume Categorie</th>
                          <th>Subcategorii</th>
                          <th>Slug</th>
                          <th>Acțiuni</th>
                        </tr>
                      </thead>
                      <tbody>
  {categoriesTree.map((cat) => (
    <RenderCategoryRows 
      key={cat.id} 
      category={cat} 
      handleEdit={handleEdit} 
      handleDelete={handleDelete} 
    />
  ))}
</tbody>
                    </Table>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>{isEdit ? "Editează Categoria" : "Categorie Nouă"}</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label>Nume</Label>
              <Input 
                type="text"  
                value={currentCategory.name} 
                onChange={(e) => { setCurrentCategory({...currentCategory, name: e.target.value});

                handleNameChange(e);
              
                }} 
                required 
              />
            </FormGroup>


            <FormGroup>
  <Label>Slug (URL)</Label>
  <Input 
    type="text" 
    placeholder="ex: haine-barbati (lasă gol pentru auto-generare)"
    value={currentCategory.slug} 
    onChange={(e) => setCurrentCategory({...currentCategory, slug: e.target.value})} 
  />
  <small className="text-muted">Slug-ul este folosit în URL-ul paginii.</small>
</FormGroup>


            
<FormGroup>
  <Label>Părinte</Label>
  <Input 
    type="select" 
    value={currentCategory.parent_id || ""} 
    onChange={(e) => setCurrentCategory({...currentCategory, parent_id: e.target.value})}
  >
    <option value="">Niciunul (Categorie Principală)</option>
    {dropdownOptions
      .filter(c => c.id !== currentCategory.id) // Prevent self-selection
      .map(c => (
        <option key={c.id} value={c.id}>
          {"—".repeat(c.depth)} {c.depth > 0 ? " " : ""}{c.name}
        </option>
      ))
    }
  </Input>
</FormGroup>

            <FormGroup className="mb-3">
              <Label>Iconiță Personalizată (PNG / Imagine)</Label>
              <Input 
                type="file" 
                onChange={handleFileChange} 
                accept="image/*"
              />
              {currentCategory.image_url && !selectedFile && (
                <div className="mt-2">
                  <small className="text-muted d-block mb-1">Imagine curentă:</small>
                  <img src={currentCategory.image_url} alt="current" style={{ height: "40px" }} />
                </div>
              )}
            </FormGroup>

            <FormGroup>
              <Label>Sau Iconiță FontAwesome (ex: fa-car)</Label>
              <Input 
                type="text" 
                value={currentCategory.icon} 
                onChange={(e) => setCurrentCategory({...currentCategory, icon: e.target.value})} 
              />
            </FormGroup>

            <Button color="primary" type="submit" className="mt-3 w-100">
              {isEdit ? "Actualizează Categoria" : "Salvează Categoria"}
            </Button>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default Categories;